import { createReducer, on } from "@ngrx/store";
import { setResumeUpload } from "../actions/resume.action";

const initalData: boolean = false;
export const resumeReducer = createReducer(
  initalData,
  on(setResumeUpload, (_, action) => action.resume_upload),
);